<template>
  <div
    id="app"
    :style="cssVariables"
    style="width: 100vw; height: 100vh; overflow: hidden"
  >
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: window.innerWidth + "px",
      windowHeight: window.innerHeight + "px",
    };
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    cssVariables() {
      return {
        "--windowWidth": `${this.windowWidth}`,
        "--window-height": `${this.windowHeight}`,
      };
    },
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth + "px";
      this.windowHeight = window.innerHeight + "px";
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  vertical-align: middle;
}

.el-select-dropdown {
  border-radius: 8px !important;
  box-shadow: 0 4px 8px 0 rgba(37, 45, 61, 0.1) !important;
  border: 1px solid #f0f4fa !important;

  .el-select-dropdown__list {
    .el-select-dropdown__item {
      color: #1d2129;
      /* 14/CN-Regular */
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }
}
</style>
